export function generateCUrl(body, path, baseURL) {
    return "curl -XPOST -H \"Content-type: application/json\" -d " + JSON.stringify(body) + " \"" + baseURL + path + "\"";
}
